export default "__VITE_ASSET__DuJ1bld1__"